module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-10.008f4b3e.mp3";